import React from 'react';

const Loader = () => {
  return (
    <div className='justify-self-center'>
      <div className="w-10 h-10 border-4 border-t-4 border-gray-200 border-t-primary rounded-full animate-spin"></div>
      </div>
  );
};

export default Loader;
